import React from 'react';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';

const AuthWrapper = (props) => {
    let history = useHistory();
    return (
        props.showCompanyDetails ?
        <div style = {{border: 'none', display: 'initial'}} onClickCapture = {(e) => {
            if(props.user && !props.user.loggedUser && !props.session.isReadOnly){
                e.stopPropagation();
                e.preventDefault();
                if (props.isEnrich) {
                    history.push('/contractor-login/v4');
                }
                if(props.user.noUserCheck) {
                    history.push('/products/login');
                } else {
                    history.push('/products/auth');
                }
            }
        }}>
            {props.children}
        </div>
        :
            <>
                {props.children}
            </>
    );
};

const mapStateToProps = state => {
	return {
        session: state.session,
        user: state.session.user,
        source: state.session.source,
        showCompanyDetails: state.session.showCompanyDetails,
        isEnrich: (state.products?.isEnrich || false)
	};
};

export default connect(mapStateToProps, {})(AuthWrapper);